import React, { FC } from 'react';

import businessHoursResource from 'src/actions/businessHours/businessHoursResource';
import FormPage from '../shared/FormPage';
import SLABusinessHoursForm from './SLABusinessHoursForm';
import useResource, { STATUS_LOADING } from 'src/presentation/hooks/useResource';

const SLABusinessHours: FC = () => {
  const { errors, loadingState } = useResource(businessHoursResource);

  const description = (
    <div data-aid="sla-business-hours-description">
      Set the Business Hours for your SLA. To learn more, visit our{' '}
      <a
        data-aid="sla-business-hours-help-link"
        target="_blank"
        rel="noopener noreferrer"
        href="https://help.gladly.com/docs/what-is-sla-business-hours"
      >
        Help Docs
      </a>
      .
    </div>
  );

  return (
    <FormPage
      isLoading={loadingState === STATUS_LOADING}
      form={SLABusinessHoursForm}
      title="SLA Business Hours"
      description={description}
      errors={errors}
      item={{}}
      resetErrors={businessHoursResource.actions.resetErrors}
      fillHeight={true}
      data-aid="sla-business-hours-page"
    />
  );
};

export default SLABusinessHours;
